/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast.
 * layout/theme.liquid loads it.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// product-info.js updateButtonPrice() rewrites the button price with innerHTML,
// dropping the visually hidden sale and regular price names.
(function () {
  const SELECTOR = '.btn__price[data-product-price]';
  const NBSP = String.fromCharCode(160);

  function hiddenLabel(text) {
    const span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = text + NBSP;
    return span;
  }

  function selectedVariant(price) {
    const json = price
      .closest('product-info')
      ?.querySelector('variant-selects [data-selected-variant]')?.textContent;
    return json ? JSON.parse(json) : null;
  }

  function restoreButtonPrice(price) {
    const compare = price.querySelector('s');
    const variant = selectedVariant(price);
    const onSale = variant ? variant.compare_at_price > variant.price : Boolean(compare);
    price.classList.toggle('product__price--sale', onSale);

    if (!compare || price.querySelector(':scope > .visually-hidden')) return;
    price.prepend(hiddenLabel(price.dataset.saleLabel));
    compare.prepend(hiddenLabel(price.dataset.regularLabel));
  }

  document.querySelectorAll(SELECTOR).forEach(restoreButtonPrice);

  new MutationObserver((records) => {
    records.forEach(({ target }) => {
      if (target instanceof Element && target.matches(SELECTOR)) restoreButtonPrice(target);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
